var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Utility class exposing methods to check FeatureGate & ChangeGates
export class GateUtils {
    constructor(hostcallbacks, changeGateMap) {
        this.changeGatesInitialized = false;
        this.hostCallbacks = hostcallbacks;
        this.changeGateMap = changeGateMap || new Map();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = [];
            if (this.hostCallbacks && this.hostCallbacks.isChangeGateEnabled) {
                this.changeGateMap.forEach((_value, changeGateName) => {
                    promises.push(this.hostCallbacks.isChangeGateEnabled(changeGateName).then((isEnabled) => {
                        this.changeGateMap.set(changeGateName, isEnabled);
                    }));
                });
            }
            yield Promise.all(promises)
                .then(() => {
                this.changeGatesInitialized = true;
            })
                .catch((_error) => {
                // Handle error if necessary
            });
        });
    }
    isFeatureEnabled(featureName, defaultValue = false, scope = 'None') {
        return this.hostCallbacks && this.hostCallbacks.isFeatureEnabled
            ? this.hostCallbacks.isFeatureEnabled(featureName, scope)
                .catch(() => Promise.resolve(defaultValue))
            : Promise.resolve(defaultValue);
    }
    isChangeGateEnabled(changeGateName) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.changeGateMap) {
                // default value of changeGate is true
                return true;
            }
            if (this.changeGatesInitialized && this.changeGateMap.has(changeGateName)) {
                return this.changeGateMap.get(changeGateName);
            }
            if (!this.changeGatesInitialized && ((_a = this.hostCallbacks) === null || _a === void 0 ? void 0 : _a.isChangeGateEnabled)) {
                // change gates are not initialized yet, use await for get value
                return yield this.hostCallbacks.isChangeGateEnabled(changeGateName);
            }
            return true;
        });
    }
    isChangeGatesInitialized() {
        return this.changeGatesInitialized;
    }
    getChangeGateMap() {
        return this.changeGateMap;
    }
}
//# sourceMappingURL=gate-utils.js.map